import { Injectable, OnDestroy } from "@angular/core";
import { Subject, BehaviorSubject, fromEvent } from "rxjs";
import { takeUntil, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";

// Menu
export interface Menu {
  headTitle1?: string;
  headTitle2?: string;
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
}

@Injectable({
  providedIn: "root",
})
export class NavService implements OnDestroy {
  private unsubscriber: Subject<any> = new Subject();
  public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

  // Search Box
  public search: boolean = false;

  // Language
  public language: boolean = false;

  // Mega Menu
  public megaMenu: boolean = false;
  public levelMenu: boolean = false;
  public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

  // Collapse Sidebar
  public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

  // For Horizontal Layout Mobile
  public horizontal: boolean = window.innerWidth < 991 ? false : true;

  // Full screen
  public fullScreen: boolean = false;

  constructor(private router: Router) {
    this.setScreenWidth(window.innerWidth);
    fromEvent(window, "resize")
      .pipe(debounceTime(1000), takeUntil(this.unsubscriber))
      .subscribe((evt: any) => {
        this.setScreenWidth(evt.target.innerWidth);
        if (evt.target.innerWidth < 991) {
          this.collapseSidebar = true;
          this.megaMenu = false;
          this.levelMenu = false;
        }
        if (evt.target.innerWidth < 1199) {
          this.megaMenuColapse = true;
        }
      });
    if (window.innerWidth < 991) {
      // Detect Route change sidebar close
      this.router.events.subscribe((event) => {
        this.collapseSidebar = true;
        this.megaMenu = false;
        this.levelMenu = false;
      });
    }
  }

  ngOnDestroy() {
    // this.unsubscriber.next();
    this.unsubscriber.complete();
  }

  private setScreenWidth(width: number): void {
    this.screenWidth.next(width);
  }

  // MENUITEMS: Menu[] = [
   
  //   { path: "/dashboard", icon: "home", title: "Dashboard",  active: false, type: "link", bookmark: true },
  //   { path: "/calender", icon: "calender", title: "Calender",  active: false, type: "link", bookmark: true },
  //   { path: "/unpaid-overtime-payments", icon: "calender", title: "UnPaid OverTime",  active: false, type: "link", bookmark: true },
  //   { path: "/master/leave-calculation", icon: "calender", title: "Leave Calculation",  active: false, type: "link", bookmark: true },

  //   {
  //     title: "Masters",
  //     icon: "home",
  //     type: "sub",
  //     badgeType: "light-primary",
  //     // badgeValue: "2",
  //     active: true,
  //     children: [
  //       { path: "/master/staffs", title: "Staffs", type: "link" },
  //       { path: "/master/staff-ticket-logs", title: "Ticket Logs", type: "link" },
  //       { path: "/master/holidays", title: "Holidays", type: "link" },
  //       // { path: "/master/staff-advances", title: "Advances", type: "link" },
  //   { path: "/master/staff-advances/consolidated-staff-advances", icon: "calender", title: "Staff Advances",  active: false, type: "link", bookmark: true },

  //       { path: "/master/overtime-payments", title: "Overtime Payments", type: "link" },


  //       // { path: "/calender", title: "Calender", type: "link" },

  //     ],
  //   },
  //   {
  //     title: "Reports",
  //     icon: "widget",
  //     type: "sub",
  //     badgeType: "light-primary",
  //     // badgeValue: "2",
  //     active: true,
  //     children: [
  //       { path: "/reports/staff-leave-report", title: "Staff Leave Report", type: "link" },
  //       { path: "/reports/staff-eos-report", title: "EOS Report", type: "link" },
  //       { path: "/reports/staff-advance-report", title: "Staff Advance Report", type: "link" },
  //       { path: "/reports/staff-ticket-report", title: "Staff Ticket Report", type: "link" },
  //       { path: "/reports/staff-ticket-eligibility-report", title: "Ticket Eligibility Report", type: "link" },
  //       { path: "/reports/staff-work-log-consolidated-report", title: "Work Log Consolidated Report", type: "link" },
  //       { path: "/reports/overtime-payments-report", title: "OverTime Payments Report", type: "link" },
  //       { path: "/reports/staff-detailed-report", title: "Staff Detailed Report", type: "link" },
  //       { path: "/reports/leave-payment-report", title: "Leave Payment Report", type: "link" },
  //       // { path: "/calender", title: "Calender", type: "link" },

  //     ],
  //   },
  // ];


  MENUITEMS: Menu[] = [
   
    { path: "/dashboard", icon: "home", title: "Kitchen Dashboard",  active: false, type: "link", bookmark: true },
    { path: "/running-orders", icon: "widget", title: "Orders",  active: false, type: "link", bookmark: true },
    { path: "/running-orders-display", icon: "widget", title: "Display",  active: false, type: "link", bookmark: true },

    // {
    //   title: "Masters",
    //   icon: "home",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   // badgeValue: "2",
    //   active: true,
    //   children: [
    //     { path: "/master/staffs", title: "Staffs", type: "link" },
    //     { path: "/master/staff-ticket-logs", title: "Ticket Logs", type: "link" },
    //     { path: "/master/holidays", title: "Holidays", type: "link" },
    //     // { path: "/master/staff-advances", title: "Advances", type: "link" },
    // { path: "/master/staff-advances/consolidated-staff-advances", icon: "calender", title: "Staff Advances",  active: false, type: "link", bookmark: true },

    //     { path: "/master/overtime-payments", title: "Overtime Payments", type: "link" },


    //     // { path: "/calender", title: "Calender", type: "link" },

    //   ],
    // },
    // {
    //   title: "Reports",
    //   icon: "widget",
    //   type: "sub",
    //   badgeType: "light-primary",
    //   // badgeValue: "2",
    //   active: true,
    //   children: [
    //     // { path: "/reports/staff-leave-report", title: "Staff Leave Report", type: "link" },
    //     // { path: "/reports/staff-eos-report", title: "EOS Report", type: "link" },
    //     // { path: "/reports/staff-advance-report", title: "Staff Advance Report", type: "link" },
    //     // { path: "/reports/staff-ticket-report", title: "Staff Ticket Report", type: "link" },
    //     // { path: "/reports/staff-ticket-eligibility-report", title: "Ticket Eligibility Report", type: "link" },
    //     // { path: "/reports/staff-work-log-consolidated-report", title: "Work Log Consolidated Report", type: "link" },
    //     // { path: "/reports/overtime-payments-report", title: "OverTime Payments Report", type: "link" },
    //     // { path: "/reports/staff-detailed-report", title: "Staff Detailed Report", type: "link" },
    //     // { path: "/reports/leave-payment-report", title: "Leave Payment Report", type: "link" },
    //     // { path: "/calender", title: "Calender", type: "link" },

    //   ],
    // },
  ];

  // Array
  items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
}
